<app-admin-nav></app-admin-nav>
<div class="container" style="margin-top: 40px; padding: 30px">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Ambassador Invites</h5>
      <button type="button" class="btn btn-primary btn-sm" (click)="openCreateModal()">
        <i class="fa fa-plus"></i> Generate Invite
      </button>
    </div>

    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th>Label</th>
              <th>Package</th>
              <th>Status</th>
              <th>Expires</th>
              <th>Invite Link</th>
              <th class="text-end">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let invite of invites">
              <td>{{ invite.label || '—' }}</td>
              <td>{{ invite.package?.description }}</td>
              <td>
                <span class="badge bg-success" *ngIf="!invite.is_used && !isExpired(invite)">Active</span>
                <span class="badge bg-secondary" *ngIf="invite.is_used">Used</span>
                <span class="badge bg-danger" *ngIf="!invite.is_used && isExpired(invite)">Expired</span>
              </td>
              <td>{{ invite.expires_at ? (invite.expires_at | date:'medium') : 'Never' }}</td>
              <td>
                <input type="text" class="form-control form-control-sm" readonly [value]="getInviteLink(invite.token)" style="width: 250px; display: inline-block;">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copyLink(invite.token)">
                  <i class="fa fa-copy"></i>
                </button>
              </td>
              <td class="text-end">
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteInvite(invite.id)" *ngIf="!invite.is_used">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="invites.length === 0">
              <td colspan="6" class="text-center py-4">No invites created yet.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Create Invite Modal -->
<div class="modal" tabindex="-1" [ngClass]="{ 'd-block': showCreateModal }" *ngIf="showCreateModal" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Generate Ambassador Invite</h5>
        <button type="button" class="btn-close" (click)="closeCreateModal()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Label (optional)</label>
          <input type="text" class="form-control" [(ngModel)]="newLabel" placeholder="e.g. Ambassador - John Smith">
        </div>
        <div class="mb-3">
          <label class="form-label">Package <sup class="text-danger">*</sup></label>
            <select class="form-select" [(ngModel)]="newPackageId">
			  <option value="" disabled selected>Select a package</option>
			  <option *ngFor="let pkg of packages" [value]="pkg.id" [title]="pkg.description" >
			    {{ truncate(pkg.description) }} - ${{ pkg.price }}
			  </option>
			</select>
        </div>
        <div class="mb-3">
          <label class="form-label">Expires In (days)</label>
          <input type="number" class="form-control" [(ngModel)]="newExpiresInDays" placeholder="30">
          <small class="text-muted">Leave blank for no expiry</small>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeCreateModal()">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="!newPackageId" (click)="createInvite()">Generate</button>
      </div>
    </div>
  </div>
</div>